module.exports = __webpack_public_path__ + "static/media/red-footer.1fa776df.png";